/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTarget = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M19.965 12.75a8 8 0 0 1-7.215 7.215V22h-1.5v-2.035a8 8 0 0 1-7.215-7.215H2v-1.5h2.035a8 8 0 0 1 7.215-7.215V2h1.5v2.035a8 8 0 0 1 7.215 7.215H22v1.5zM11.25 5.543V7.5h1.5V5.543a6.5 6.5 0 0 1 5.707 5.707H16.5v1.5h1.957a6.5 6.5 0 0 1-5.707 5.707V16.5h-1.5v1.957a6.5 6.5 0 0 1-5.707-5.707H7.5v-1.5H5.543a6.5 6.5 0 0 1 5.707-5.707" clipRule="evenodd" /></svg>;
export default SvgTarget;